  <template>
  <page>
    <lazy-div>
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else-if="reviewMode">mdi-pencil</v-icon>
          <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
          <v-toolbar-title v-if="newMode">Create New Claims Limit per User</v-toolbar-title>
          <v-toolbar-title v-else-if="reviewMode">Edit Claims Limit per User</v-toolbar-title>
          <v-toolbar-title v-else-if="queryMode">Query Claims Limit per User</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <message :messages="messages"></message>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-flex xs12 md9 lg9 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.usrId }}</v-subheader>
                <div class="queryValue">{{ form.usrId }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9 v-else>
                <v-text-field
                  v-model="form.usrId"
                  :label="labels.usrId"
                  :error-messages="errors.collect('usrId')"
                  data-vv-name="usrId"
                  :data-vv-as="labels.usrId"
                  v-validate="'required'"
                  append-icon="mdi-magnify"
                  @click="getHelpList('user')"
                  readonly
                />
              </v-flex>

              <v-flex xs12 md3 lg3>
                <v-subheader class="queryLabel">{{ labels.userRole }}</v-subheader>
                <div class="queryValue">{{ form.userRole }}</div>
              </v-flex>

              <v-flex xs12 md9 lg9 v-if="!newMode">
                <v-subheader class="queryLabel">{{ labels.cls }}</v-subheader>
                <div class="queryValue">{{ form.cls }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9 v-else>
                <v-text-field
                  v-model="form.cls"
                  :label="labels.cls"
                  :error-messages="errors.collect('cls')"
                  data-vv-name="cls"
                  :data-vv-as="labels.cls"
                  append-icon="mdi-magnify"
                  @click="getHelpList('busCls')"
                  readonly
                  clearable
                />
              </v-flex>

              <v-flex xs12 md9 lg9 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.maxRes }}</v-subheader>
                <div class="queryValue">{{ formatDisplayNumber(form.maxRes) }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9 v-else>
                <v-text-field
                  v-model="form.maxRes"
                  v-num-mask="{ intScale: 10, decScale: 2 }"
                  :label="labels.maxRes"
                  :error-messages="errors.collect('maxRes')"
                  data-vv-name="maxRes"
                  :data-vv-as="labels.maxRes"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md9 lg9 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.maxPayt }}</v-subheader>
                <div class="queryValue">{{ formatDisplayNumber(form.maxPayt) }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9 v-else>
                <v-text-field
                  v-model="form.maxPayt"
                  v-num-mask="{ intScale: 10, decScale: 2 }"
                  :label="labels.maxPayt"
                  :error-messages="errors.collect('maxPayt')"
                  data-vv-name="maxPayt"
                  :data-vv-as="labels.maxPayt"
                ></v-text-field>
              </v-flex>

              <v-flex xs12 md9 lg9 v-if="queryMode">
                <v-subheader class="queryLabel">{{ labels.maxInc }}</v-subheader>
                <div class="queryValue">{{ formatDisplayNumber(form.maxInc) }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9 v-else>
                <v-text-field
                  v-model="form.maxInc"
                  v-num-mask="{ intScale: 10, decScale: 2 }"
                  :label="labels.maxInc"
                  :error-messages="errors.collect('maxInc')"
                  data-vv-name="maxInc"
                  :data-vv-as="labels.maxInc"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout>
              <v-flex xs12 md9 lg9>
                <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
                <div class="queryValue">{{ createdBy }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9>
                <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(createdDate) }}</div>
              </v-flex>
            </v-layout>
            <v-layout v-if="!newMode">
              <v-flex xs12 md9 lg9>
                <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
                <div class="queryValue">{{ modifiedBy }}</div>
              </v-flex>
              <v-flex xs12 md9 lg9>
                <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
                <div class="queryValue">{{ formatDisplayDate(modifiedDate) }}</div>
              </v-flex>
            </v-layout>
          </v-container>
          <v-container fluid grid-list-lg>
            <v-layout row wrap>
              <v-btn class="mr-2" color="error" @click="doCancel" :loading="submitting">
                <span>Cancel</span>
                <v-icon right dark>mdi-cancel</v-icon>
              </v-btn>
              <v-btn :disabled="queryMode" color="primary" dark @click="doSave" :loading="submitting">
                Save
                <v-icon>mdi-content-save</v-icon>
              </v-btn>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
      <!-- helplist -->
      <v-dialog v-model="showBusClsList" width="1280px">
        <busCls-help-list @close="showBusClsList = false" @assign-busCls="assignBusCls"></busCls-help-list>
      </v-dialog>
      <v-dialog v-model="showUserList" width="1280px">
        <user-help-list @close="showUserList = false" @assign-user="assignUser"></user-help-list>
      </v-dialog>
    </lazy-div>
  </page>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatDisplayNumber, removeFormatNumber } from '@/utils/number'
import { expandURI } from '@/utils/ajax'
import UserHelpList from '@/components/core/common/dialog/UserHelpList'
import BusClsHelpList from '@/components/core/common/dialog/BusClsHelpList'
export default {
  data() {
    return {
      labels: {
        usrId: 'User ID*',
        userRole: 'Role Level',
        cls: 'Business Class',
        maxRes: 'Maximum Reserve',
        maxPayt: 'Maximum Payment',
        maxInc: 'Maximum Incurred',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date'
      },
      form: {
        usrId: null,
        userRole: 0,
        cls: null,
        maxRes: '0.00',
        maxPayt: '0.00',
        maxInc: '0.00'
      },
      newMode: false,
      queryMode: false,
      reviewMode: false,
      submitting: false,
      createdBy: this.$store.state.token.firstName + ' ' + this.$store.state.token.lastName,
      createdDate: new Date(),
      modifiedBy: '',
      modifiedDate: undefined,
      showUserList: false,
      showBusClsList: false
    }
  },
  methods: {
    formatDisplayDate(xDate) {
      return formatDisplayDate(xDate)
    },
    async doFetch() {
      const apiURI = this.menu.getUsrClmLim
      if (apiURI) {
        this.loading = true
        try {
          const result = await this.$http.put(apiURI, this.objParam)
          const { data } = result.data
          if (data) {
            this.form.usrId = data.usrClmLim.usrId + ' - ' + data.usrClmLim.name
            this.form.cls = data.usrClmLim.cls
            this.form.maxRes = formatDisplayNumber(data.usrClmLim.maxRes)
            this.form.maxPayt = formatDisplayNumber(data.usrClmLim.maxPayt)
            this.form.maxInc = formatDisplayNumber(data.usrClmLim.maxInc)
            this.createdBy = data.createdBy
            this.createdDate = data.createdDate
            this.modifiedBy = data.modifiedBy
            this.modifiedDate = data.modifiedDate
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getUsrRole() {
      const apiURI = this.menu.getUsrRole
      if (apiURI) {
        this.loading = true
        try {
          const expand = { usrId: this.form.usrId.split(' ')[0] }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.form.userRole = data.role.roleLvl
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doCancel() {
      this.$router.push({ name: 'usrClmLim' })
    },
    doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.newMode) {
            this.doCreate()
          } else if (this.reviewMode) {
            this.doUpdate()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreate() {
      const apiURI = this.menu.create
      if (apiURI) {
        this.submitting = true
        try {
          const cls = this.form.cls ? this.form.cls.split(' ')[0] : ''
          const expand = {
            usrId: this.form.usrId.split(' ')[0],
            cls: cls,
            maxRes: removeFormatNumber(this.form.maxRes),
            maxPayt: removeFormatNumber(this.form.maxPayt),
            maxInc: removeFormatNumber(this.form.maxInc)
          }
          const result = await this.$http.post(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
            this.message(data)
            this.fieldMessage(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.menu.update
      if (apiURI) {
        this.submitting = true
        try {
          const cls = this.form.cls ? this.form.cls.split(' ')[0] : ''
          const expand = {
            usrId: this.form.usrId.split(' ')[0],
            cls: cls,
            maxRes: removeFormatNumber(this.form.maxRes),
            maxPayt: removeFormatNumber(this.form.maxPayt),
            maxInc: removeFormatNumber(this.form.maxInc)
          }
          const result = await this.$http.put(apiURI, expand)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCancel()
          }
          this.submitting = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response.data
          if (data) {
            this.notify(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getHelpList(fieldName) {
      this.resetMessages()
      if (fieldName === 'user') {
        this.showUserList = true
        this.showBusClsList = false
      } else {
        this.showUserList = false
        this.showBusClsList = true
      }
    },
    assignUser(user) {
      this.form.usrId = user.usrId + ' - ' + user.firstName + ' ' + user.lastName
      this.$validator.validate('usrId')
      this.showUserList = false
    },
    assignBusCls(busCls) {
      this.form.cls = busCls.busCls + ' - ' + busCls.busClsDesc
      this.showBusClsList = false
    },
    doClose() {
      this.helplist = false
      this.polTypeHelpList = false
      this.schemeHelpList = false
      this.busClsHelpList = false
    },
    formatDisplayNumber(xNum) {
      return formatDisplayNumber(xNum)
    }
  },
  computed: {
    menu() {
      return this.$store.state.usrClmLimParam.menu
    },
    modeParam() {
      return this.$route.params.paramMode
    },
    objParam() {
      return this.$route.params.paramObjRes
    }
  },
  mounted() {},
  created() {
    if (this.modeParam === 'new') {
      this.newMode = true
    } else if (!this.modeParam) {
      this.doCancel()
    } else {
      if (this.modeParam === 'query') {
        this.queryMode = true
      } else if (this.modeParam === 'review') {
        this.reviewMode = true
      }
      this.doFetch()
    }
  },
  watch: {
    'form.usrId': function (value) {
      this.getUsrRole()
    }
  },
  mixins: [MessageMixin],
  components: {
    BusClsHelpList,
    UserHelpList
  }
}
</script>
